module.exports = __webpack_public_path__ + "static/media/OutliersQ5_2.95a224c5.svg";